module.exports = __webpack_public_path__ + "static/teaching_outline-4dc34c34f1e25ca687cafd6fd8d0c009.png";